import { Occupancy } from './occupancy';

export class Reservation {

    constructor() {
        this.Occupancies = [];
    }

    ReservationId: number;

    Designation: string;

    PersonId: number;

    ResourceId: number;

    Resource: string;

    ResourceType: string;

    ResourceTypeId: number;

    FurtherInformation: string;

    Status: string;

    StatusRemark: string;

    StatusId: number;

    IsCancelable: boolean;

    IsEditable: boolean;

    Occupancies: Array<Occupancy>;

    static create(object: Reservation): Reservation {
        const instance = new Reservation();
        instance.ReservationId = object.ReservationId;
        instance.Designation = object.Designation;
        instance.PersonId = object.PersonId;
        instance.ResourceId = object.ResourceId;
        instance.Resource = object.Resource;
        instance.ResourceType = object.ResourceType;
        instance.ResourceTypeId = object.ResourceTypeId;
        instance.FurtherInformation = object.FurtherInformation;
        instance.Status = object.Status;
        instance.StatusRemark = object.StatusRemark;
        instance.StatusId = object.StatusId;
        instance.IsCancelable = object.IsCancelable;
        instance.IsEditable = object.IsEditable;
        instance.Occupancies = object.Occupancies ? object.Occupancies.map(o => Occupancy.create(o)) : [];
        return instance;
    }

    hasFutureSavedDates(): boolean {
        if (this.Occupancies === null) { return false; }

        const now = new Date();
        for (let i = 0; i < this.Occupancies.length; i++) {
            if (this.Occupancies[i].LessonId && this.Occupancies[i].DateTimeFrom > now) {
                return true;
            }
        }
        return false;
    }

}
